/**
 * @ngdoc Controller
 * @name ForgotPasswordController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /**
     * @constructor
     * @ngInject
     */
    function ForgotPasswordController($scope, ForgotPasswordService, LoginService) {
        /**
         * Bind to model
         */
        $scope.model = ForgotPasswordService.model;

        /**
         * Flag to hide a submitted form and show a service message
         * @type {boolean}
         */
        $scope.requestReceived = false;

        // Pre-fill emailadress
        if (LoginService.loginModel.username)
        {
            $scope.model.email = LoginService.loginModel.username;
        }

        /**
         * Handle password reset request interface logic
         */
        $scope.requestPasswordReset = function() {
            if (!$scope.forgotpasswordForm.$valid) return;

            ForgotPasswordService
                .requestPasswordReset()
                .then(function(success) {
                    // If request was successful show
                    if (success) {
                        $scope.requestReceived = true;
                    }
                });
        };
    }

})();
